/*
 * File: d:\projects\AutoFiFront\src\Content\Car\CarsDisplay\CarsDisplay.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Thursday February 23rd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday February 23rd 2023 5:22:39 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React from "react";
import styles from "Content/Car/CarsDisplay/CarsDisplay.module.css";
import { CarCardPropsType } from "Content/Car/CarCard/CarCard.type";
import CarCard from "Content/Car/CarCard/CarCard";
import Cookie from "Cookies/CookieWrapper";
import CookiePathResolver from "Config/Cookies/CookiePathResolver";

type CarsDisplayType= {
    carList : any[],
    themeColor : string,
}

function CarsDisplay (props: CarsDisplayType){
    const myCookies: number[] = Cookie.getCookie(CookiePathResolver.CAR.FAVORITE);

    const checkIsLiked = (id: number) => {
        return myCookies !== undefined && myCookies.includes(id);
    };

    const getRandomArbitrary = (min: number, max: number) => {
        return Math.floor(Math.random() * (max - min) + min);
    };

    return (
        <React.Fragment>
            <div className={`${styles.container}`}>
                {
                    props.carList.map((car: CarCardPropsType, index: number) => { return <CarCard hasEllipsis={true} key={`${car.id + (index + 1) * getRandomArbitrary(34,4895)}`} {...car } IsFav={checkIsLiked(car.id)} themeColor={props.themeColor}/>})
                }
            </div>
        </React.Fragment>
    );
}

export default CarsDisplay;
